import { QueryDispatcher } from "../../shared/domain/QueryDispatcher";

export class BankAccountList {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(company_id:String|Number, bank_account_id:string): Promise<any> {
    let args = { 
      company_id: company_id,
    }
    let data = await this.dispatcher.dispatch('bank_account.data', args)
    if (data.status === '200') {
      this.frontend.bank_accounts = data.data
      this.frontend.bank_account_list=[]
      for(let i in this.frontend.bank_accounts) {
        if (!this.frontend.bank_accounts[i].avoid_detect_transfer_between_accounts
           && this.frontend.bank_accounts[i].id != bank_account_id 
           && !this.frontend.bank_account_list.includes(this.frontend.bank_accounts[i].cuenta_bancos)){
          this.frontend.bank_account_list.push(this.frontend.bank_accounts[i].cuenta_bancos)
        }
      }
    } else {
      return 'There is no data for this company id'
    }
  }
}